import Vue from 'vue';
import http from '../api/httpRequest.js';

export default {
    state: {
        sendIdKey: 'tgUserId',
        // 渠道
        channels: [],
        // 当前渠道
        activeChannel: null,
        // 账号
        accounts: [],
        // 当前账号
        activeAccount: null,
        // 账号加载状态
        accountLoading: false,
        // 会话列表
        chats: [],
        // 当前会话
        activeChat: null,
        // 会话加载状态
        chatLoading: false,
        // 会话聊天历史
        chatHistory: [],
        // 当前用户画像
        userPortraitMongo: null,
        // 分组列表
        groupList: [],
        // 历史记录分页
        historyPage: 1,
        historyPageSize: 15,
        historyTotal: 0,
        // 账号列表折叠状态
        accountListCollapsed: false,
        hasInteracted: false,
        channelsLoaded: false,
        // 设备信息
        WebEnv: null,
    },
    mutations: {
        // 渠道
        setChannels(state, channels) {
            state.channels = channels;
            state.channelsLoaded = true;
        },
        activeChannel(state, { context, channelId }) {
            let channel = state.channels.find((k) => k.id === channelId);
            if (channel) {
                state.activeChannel = channel;
            } else if (state.channels.length > 0) {
                state.activeChannel = state.channels[0];
            }
            state.accounts = [];
            state.chats = [];
            state.chatHistory = [];
            state.activeAccount = null;
            state.activeChat = null;
            context.dispatch('loadAccount');
        },
        // 账号
        setAccounts(state, accounts) {
            state.accounts = accounts;
        },
        // 标记某账号"有未读"（用于非当前账号收到新消息时点亮红点；
        // 当前账号的红点由其会话未读求和决定，见 setChats）
        markAccountUnread(state, accountId) {
            const account = state.accounts.find(a => a.accountId == accountId);
            if (account) {
                // 用 Vue.set 兜底字段不存在时的响应式（纯前端字段，后端不返回）
                Vue.set(account, 'hasUnread', true);
            }
        },
        activeAccount(state, { context, accountId }) {
            state.activeAccount = state.accounts.find((k) => k.id === accountId);
            state.chats = [];
            state.chatHistory = [];
            state.activeChat = null;
            context.dispatch('loadCicadeChat');
        },
        setAccountLoading(state, loading) {
            state.accountLoading = loading;
        },
        // 会话列表
        setChats(state, chats) {
            state.chats = chats;
            // 当前账号红点 = 其任一会话有未读。统一在此出口重算，
            // 既保证与会话未读一致，也不受消息重复推送影响（布尔，幂等）。
            if (state.activeAccount) {
                const hasUnread = (chats || []).some(c => (c.unreadCount || 0) > 0);
                Vue.set(state.activeAccount, 'hasUnread', hasUnread);
            }
        },
        // 当前会话
        setActiveChat(state, { context, chatId }) {
            state.activeChat = state.chats.find((k) => k.chatId === chatId);
        },
        setChatLoading(state, loading) {
            state.chatLoading = loading;
        },
        // 账号列表折叠状态
        toggleAccountListCollapsed(state) {
            state.accountListCollapsed = !state.accountListCollapsed;
        },
        // 会话聊天历史
        setChatHistory(state, chatHistory) {
            state.chatHistory = chatHistory;
        },
        // 当前用户画像
        setUserPortraitMongo(state, userPortraitMongo) {
            state.userPortraitMongo = userPortraitMongo;
        },
        // 分组列表
        setGroupList(state, groupList){
            state.groupList = groupList;
        },
        // 插入分组
        setAddGroup(state, groupInfo) {
            const { groupId, chatId, groupName } = groupInfo;
            if (!groupId || !chatId) return;

            const chatInfo = state.chats.find(c => c.chatId == chatId);

            if (!chatInfo) return;

            state.groupList = state.groupList.map(group => {
                // ① 先从所有分组移除该 chat
                const filteredChats = group.chats.filter(c => c.chatId != chatId);
                const filteredChatIds = group.chatIds.filter(id => id != chatId);

                // ② 目标分组：加入 chat
                if (group.id == groupId) {
                return {
                    ...group,
                    chats: [...filteredChats, chatInfo],
                    chatIds: [...filteredChatIds, chatId]
                };
                }

                // ③ 非目标分组：只做移除
                return {
                    ...group,
                    chats: filteredChats,
                    chatIds: filteredChatIds
                };
            });

            // ④ 如果目标分组不存在，新建
            if (!state.groupList.some(g => g.id == groupId)) {
                    state.groupList.push({
                    id: groupId,
                    groupName,
                    chats: [chatInfo],
                    chatIds: [chatId],
                    isShow: true
                });
            }
        },
        // 插入分组
        setCustAddGroup(state, groupInfo) {
            const { groupId, chatId, groupName, userChat, groupType} = groupInfo;
            if (!groupId || !chatId) return;
            // 防御：只处理当前账号的入组事件。同一访客(chatId)可能同时跟多个账号聊天，
            // 若不校验 accountId，别的账号的入组事件会按 chatId 把当前账号的会话从分组里挪走(看着像"消失")
            if (groupInfo.accountId != null && state.activeAccount && groupInfo.accountId != state.activeAccount.accountId) {
                return;
            }
            let chatInfo = !userChat?state.chats.find(c => c.chatId == chatId):userChat
            if (!chatInfo) return;
            chatInfo.unreadCount == 1?chatInfo.unreadCount = 0:chatInfo.unreadCount;
            state.groupList = state.groupList.map(group => {
                // ① 先从所有分组移除该 chat
                const filteredChats = group.chats.filter(c => c.chatId != chatId);
                const filteredChatIds = group.chatIds.filter(id => id != chatId);

                // ② 目标分组：加入 chat
                if (group.id == groupId) {
                return {
                    ...group,
                    chats: [chatInfo, ...filteredChats],
                    chatIds: [chatId, ...filteredChatIds]
                };
                }

                // ③ 非目标分组：只做移除
                return {
                    ...group,
                    chats: filteredChats,
                    chatIds: filteredChatIds
                };
            });

            // ④ 如果目标分组不存在，新建
            if (!state.groupList.some(g => g.id == groupId)) {
                    state.groupList.push({
                    id: groupId,
                    groupName,
                    chats: [chatInfo],
                    chatIds: [chatId],
                    isShow: true
                });
            }
        },
        // 展开收起
        toggleGroup(state, item){
            state.groupList.forEach((i)=>{
                if(i.id == item.id){
                    i.isShow = !i.isShow;
                }else{
                    i.isShow = false;
                }
            })
        },
        // 清空分组
        removeGroup(state) {
            state.groupList = [];
        },
        // 添加ai未回复消息的提示
        addChatMarks(state, chatId) {
            const chat = state.chats.find(c => c.chatId == chatId);
            if (chat) {
              if (!Array.isArray(chat.marks)) {
                chat.marks = [];
              }
              if (!chat.marks.includes('disconnect')) {
                chat.marks.push('disconnect');
              }
            }

            // 分组列表
            const groupList = state.groupList || [];
            groupList.forEach(group => {
                const groupChat = group.chats?.find(c => c.chatId == chatId);
                if (groupChat) {
                    if (!Array.isArray(groupChat.marks)) {
                        groupChat.marks = []
                    }
                    if (!groupChat.marks.includes('disconnect')) {
                        groupChat.marks.push('disconnect');
                    }
                }
            });
        },
        // 去除ai未回复消息的提示
        clearChatMarks(state, chatId) {
            const chat = state.chats.find(c => c.chatId == chatId);
            if (chat) {
                const index = chat.marks.indexOf('disconnect')
                if (index !== -1) {
                    chat.marks.splice(index, 1)
                }
            }
            // 分组列表
            state.groupList?.forEach(group => {
                const groupChat = group.chats?.find(c => c.chatId == chatId);
                if (groupChat) {
                    const index = groupChat.marks.indexOf('disconnect')
                    if (index !== -1) {
                        groupChat.marks.splice(index, 1)
                    }
                }
            });
        },
        // 添加标记
        addChatAttentionPoint(state, chatId) {
            const chat = state.chats.find(c => c.chatId == chatId);
            if (chat) {
                chat.attentionPoint = true;
            }
            // 分组列表
            state.groupList?.forEach(group => {
                const groupChat = group.chats?.find(c => c.chatId == chatId);
                if (groupChat) {
                groupChat.attentionPoint = true;
                }
            });
        },
        // 账号状态发生变化
        setAccountStatus(state, data){
            const account = state.accounts.find(c => c.accountId == data.accountId);
            if (account) {
                if(data.type == 'greetLimit'){
                    account.greetLimitStatus = 0;
                }else if(data.type == 'importLimit'){
                    account.limitStatus = 0;
                }else if(data.type == 'countLimit'){
                    account.countLimitStatus = 0;
                }
            }
        },
        // 陌生人添加到会话列表
        addStrangerToChat(state, stranger) {
            let data = {
                attentionPoint: null,
                autoAiStatus: null,
                autoTranslate: true,
                chatId: stranger.chatIdStr?stranger.chatIdStr:stranger.chatId,
                isSticky: false,
                marks: [],
                seconds: 10,
                online: stranger.online || false,
                senderId: stranger.senderId,
                stickyTime: null,
                timestamp: stranger.timestamp,
                title: stranger.title,
                unreadCount: 0,
                userType: stranger.userType
            }
            const index = state.chats.findIndex(c => c.chatId == data.chatId);
            if (index == -1) {
                state.chats.push(data);
            }
        },
        // 历史记录分页
        setHistoryPage(state, page) {
            state.historyPage = page;
        },
        // 历史记录总条数
        setHistoryTotal(state, total) {
            state.historyTotal = total;
        },
        // 修改当前账号状态
        editAccountStatus(state, status){
            state.accounts[0].status = status;
        },
        setHasInteracted(state, hasInteracted){
            state.hasInteracted = hasInteracted;
        },
        setUserWebEnv(state, WebEnv){
            state.WebEnv = WebEnv;
        },
        setChatStatus(state, data){
            console.log(data);
            const chat = state.chats.find(c => c.chatId == data.chatId);
            if (chat) {
                chat.online = data.online;
            }
            // 分组列表
            state.groupList?.forEach(group => {
                const groupChat = group.chats?.find(c => c.chatId == data.chatId);
                if (groupChat) {
                    groupChat.online = data.online;
                }
            });
        },
        readedMessagestatus(state, data) {
            const readTimestamp = Number(data.timestamp) || 0;

            state.chatHistory.forEach((chat) => {
                if ((Number(chat.timestamp) || 0) <= readTimestamp) {
                    chat.read = true;
                }
            });
        },
        // 会话设置变更同步：负责人/成员任一方改了自动翻译等设置，实时刷新另一方对应会话的开关状态
        syncChatSettings(state, data) {
            const apply = (chat) => {
                if (!chat) return;
                if (data.autoTranslate != null) chat.autoTranslate = data.autoTranslate;
                if (data.targetLanguage != null) chat.targetLanguage = data.targetLanguage;
                if (data.seconds != null) chat.seconds = data.seconds;
                if (data.autoAiStatus != null) chat.autoAiStatus = data.autoAiStatus;
            };
            // 客服渠道开关读取来源：分组列表 groupList（findChatStatusById）
            state.groupList?.forEach(group => {
                apply(group.chats?.find(c => c.chatId == data.chatId));
            });
            // 会话列表
            apply(state.chats?.find(c => c.chatId == data.chatId));
            // 当前打开的会话
            if (state.activeChat && state.activeChat.chatId == data.chatId) {
                apply(state.activeChat);
            }
        }
    },
    actions: {
        // 刷新头像
        refreshPortrait(context,accountId) {
            http({
                url: '/client/refPhoto',
                method: 'POST',
                params: {
                    accountId,
                }
            })
            .then((res) => {
                console.log(res);
            })
            .catch((res) => {
                console.log(res);
            });
        },
        // 加载渠道
        loadChannel(context) {
            return new Promise((resolve, reject) => {
                http({
                    url: '/client/getChannel',
                    method: 'GET'
                })
                    .then((channels) => {
                        //过滤掉id为8的渠道(fb)
                        channels = channels.filter(item=>{
                            return item.id !== 8
                        })
                        context.commit('setChannels', channels);
                        if(channels.length == 0) return resolve()
                        context.commit('activeChannel', {
                            context,
                            channelId: channels[0].id
                        });
                        resolve();
                    })
                    .catch((res) => {
                        reject(res);
                    });
            });
        },
        // 加载账号
        loadAccount(context) {
            return new Promise((resolve, reject) => {
                context.commit('setAccountLoading', true);
                http({
                    url: '/client/getAccounts',
                    method: 'GET',
                    params: { channelName: context.state.activeChannel.channelName }
                })
                    .then((accounts) => {
                        context.commit('removeGroup');
                        if(!accounts){
                            context.commit('setAccountLoading', false);
                            return resolve();
                        }
                        accounts = accounts.reverse();
                        context.commit('setAccounts', accounts);
                        context.commit('setAccountLoading', false);
                        // if (accounts.length > 0 && !context.state.activeAccount) {
                        //     context.commit('activeAccount', {
                        //         context,
                        //         accountId: accounts[0].id
                        //     });
                        // }

                        //更新账号
                        if (accounts.length > 0) {
                            context.commit('activeAccount', {
                                context,
                                accountId: accounts[0].id
                            });
                        }
                        resolve();
                    })
                    .catch((res) => {
                        context.commit('setAccountLoading', false);
                        reject(res);
                    });
            });
        },
        // 加载会话列表
        loadCicadeChat(context) {
            return new Promise((resolve, reject) => {
                context.commit('setChatLoading', true);
                http({
                    url: '/client/getChats',
                    method: 'GET',
                    params: { accountId: context.state.activeAccount.accountId }
                })
                    .then((chats) => {
                        // 对 chats 进行排序
                        const sortedChats = chats.sort((a, b) => {
                            // 1. isSticky 排序（true 的在前）
                            const aSticky = a.isSticky ? 1 : 0;
                            const bSticky = b.isSticky ? 1 : 0;
                            if (aSticky !== bSticky) {
                                return bSticky - aSticky;
                            }

                            // 2. stickyTime 排序（新的在前）
                            if (a.isSticky && b.isSticky) {
                                const aTime = a.stickyTime || 0;
                                const bTime = b.stickyTime || 0;
                                if (aTime !== bTime) {
                                    return bTime - aTime;
                                }
                            }

                            // 3. portrait 排序（有标记的在前）
                            const aHasPortrait = a.portraitValues != null ? 1 : 0;
                            const bHasPortrait = b.portraitValues != null ? 1 : 0;
                            if (aHasPortrait !== bHasPortrait) {
                                return bHasPortrait - aHasPortrait;
                            }

                            // 4. 时间戳排序（新在前）
                            return (b.timestamp || 0) - (a.timestamp || 0);
                        });
                        context.commit('setChats', sortedChats);
                        context.commit('setChatLoading', false);
                        context.commit('removeGroup');
                        context.dispatch('getGroupList');
                        if (sortedChats.length > 0 && context.state.activeAccount.channelName != 'customer') {
                            const chatId = sessionStorage.getItem('activeChat');
                            if(chatId){
                                context.commit('setActiveChat', {
                                    context,
                                    chatId: chatId
                                });
                            }else{
                                sessionStorage.setItem('activeChat',context.state.activeChat ? context.state.activeChat.chatId : sortedChats[0].chatId);
                                context.commit('setActiveChat', {
                                    context,
                                    chatId: context.state.activeChat ? context.state.activeChat.chatId : sortedChats[0].chatId
                                });
                            }
                        }
                        resolve();
                    })
                    .catch((res) => {
                        context.commit('setChatLoading', false);
                        reject(res);
                    });
            });
        },
        // 无感加载会话列表
        newLoadCicadeChat(context) {
            return new Promise((resolve, reject) => {
                // context.commit('setChatLoading', true);
                http({
                    url: '/client/getChats',
                    method: 'GET',
                    params: { accountId: context.state.activeAccount.accountId }
                })
                    .then((chats) => {
                        // 对 chats 进行排序
                        const sortedChats = chats.sort((a, b) => {
                            // 1. isSticky 排序（true 的在前）
                            const aSticky = a.isSticky ? 1 : 0;
                            const bSticky = b.isSticky ? 1 : 0;
                            if (aSticky !== bSticky) {
                                return bSticky - aSticky;
                            }

                            // 2. stickyTime 排序（新的在前）
                            if (a.isSticky && b.isSticky) {
                                const aTime = a.stickyTime || 0;
                                const bTime = b.stickyTime || 0;
                                if (aTime !== bTime) {
                                    return bTime - aTime;
                                }
                            }

                            // 3. portrait 排序（有标记的在前）
                            const aHasPortrait = a.portraitValues != null ? 1 : 0;
                            const bHasPortrait = b.portraitValues != null ? 1 : 0;
                            if (aHasPortrait !== bHasPortrait) {
                                return bHasPortrait - aHasPortrait;
                            }

                            // 4. 时间戳排序（新在前）
                            return (b.timestamp || 0) - (a.timestamp || 0);
                        });
                        context.commit('setChats', sortedChats);
                        // context.commit('setChatLoading', false);
                        // context.commit('removeGroup');
                        context.dispatch('getGroupList');
                        if (sortedChats.length > 0 && context.state.activeAccount.channelName != 'customer') {
                            const chatId = sessionStorage.getItem('activeChat');
                            if(chatId){
                                context.commit('setActiveChat', {
                                    context,
                                    chatId: chatId
                                });
                            }else{
                                sessionStorage.setItem('activeChat',context.state.activeChat ? context.state.activeChat.chatId : sortedChats[0].chatId);
                                context.commit('setActiveChat', {
                                    context,
                                    chatId: context.state.activeChat ? context.state.activeChat.chatId : sortedChats[0].chatId
                                });
                            }
                        }
                        resolve();
                    })
                    .catch((res) => {
                        // context.commit('setChatLoading', false);
                        reject(res);
                    });
            });
        },
        // 获取分组列表
        getGroupList({ state, commit }) {
            const accountId = state.activeAccount.accountId;
            const oldGroupList = state.groupList || [];
            return new Promise((resolve, reject) => {
                http({
                    url: '/client/getChatsV1',
                    method: 'GET',
                    params: { accountId }
                })
                .then((res) => {
                    const mergedList = res.map(newItem => {
                        const oldItem = oldGroupList.find(
                            old => old.id == newItem.id && old.accountId == accountId
                        );
                        return {
                            ...newItem,
                            accountId,
                            isShow: oldItem ? oldItem.isShow : false
                        };
                    });

                    // 分组排序
                    const sortedMergedList = mergedList.map(group => {
                        // 对每个 group 下的 chats 进行排序
                        const sortedChats = group.chats.sort((a, b) => {
                            // 1. 置顶排序 (isSticky: true 在前)
                            if ((b.isSticky ? 1 : 0) !== (a.isSticky ? 1 : 0)) {
                                return (b.isSticky ? 1 : 0) - (a.isSticky ? 1 : 0);
                            }

                            // 2. 置顶时间排序 (stickyTime: 最新的在前)
                            if (a.isSticky && b.isSticky) {
                                const aTime = Number(a.stickyTime) || 0;
                                const bTime = Number(b.stickyTime) || 0;
                                if (bTime !== aTime) return bTime - aTime;
                            }

                            // 3. 标记排序 (有 portraitValues 的在前)
                            if ((b.portraitValues ? 1 : 0) !== (a.portraitValues ? 1 : 0)) {
                                return (b.portraitValues ? 1 : 0) - (a.portraitValues ? 1 : 0);
                            }

                            // 4. 时间戳排序 (timestamp: 最新的在前)
                            const aTimestamp = a.timestamp ? Number(a.timestamp) : 0;
                            const bTimestamp = b.timestamp ? Number(b.timestamp) : 0;

                            return bTimestamp - aTimestamp; // 最新的时间戳在前
                        });

                        // 返回排序后的 group，包括排序后的 chats
                        return {
                            ...group,
                            chats: sortedChats,
                        };
                    });

                    if (sortedMergedList.length > 0 && state.activeAccount?.channelName == 'customer' && sortedMergedList[sortedMergedList.length - 1].chats.length > 0) {
                        sortedMergedList[sortedMergedList.length - 1] = {
                            ...sortedMergedList[sortedMergedList.length - 1],
                            isShow: true
                        };

                        const chatId = sessionStorage.getItem('activeChat');
                        if(chatId){
                            commit('setActiveChat', {
                                state,
                                chatId: chatId
                            });
                        }else{
                            sessionStorage.setItem('activeChat',state.activeChat ? state.activeChat.chatId : sortedMergedList[sortedMergedList.length - 1].chats[0].chatId);
                            commit('setActiveChat', {
                                state,
                                chatId: state.activeChat ? state.activeChat.chatId : sortedMergedList[sortedMergedList.length - 1].chats[0].chatId
                            });
                        }
                    }
                    commit('setGroupList', sortedMergedList);
                    resolve(sortedMergedList);
                })
                .catch((err) => {
                    reject(err);
                });
            });
        },
        // 加载会话聊天历史
        loadCicadeChatHistory(context, callback = null) {
            context.commit('setHistoryPage', 1);
            return new Promise((resolve, reject) => {
                http({
                    url: '/client/historyMessages',
                    method: 'GET',
                    params: {
                        accountId: context.state.activeAccount.accountId,
                        chatId: context.state.activeChat.chatId,
                        pageNum: context.state.historyPage,
                        pageSize: context.state.historyPageSize
                    }
                })
                .then((history) => {
                    history.list = history.list.reverse();
                    context.commit('setHistoryTotal', history.total);
                    context.commit('setChatHistory', history.list);
                    callback && callback();
                    context.dispatch('markChatAsRead', {
                        context,
                        chatId: context.state.activeChat?.chatId,
                        accountId: context.state.activeAccount.accountId
                    });
                    resolve(history.list);
                })
                .catch((res) => {
                    reject(res);
                });
            });
        },
        // ws 重连后增量补拉：把断连窗口期漏推的消息补回当前会话。
        // 仅 customer 渠道支持(后端 historyMessages 对 customer 渠道识别 sinceTimestamp 做增量查询)。
        syncCicadeChatHistory(context) {
            const account = context.state.activeAccount;
            const chat = context.state.activeChat;
            if (!account || !account.accountId || !chat || !chat.chatId) {
                return;
            }
            // 非 customer 渠道后端不识别 sinceTimestamp，避免误把降序分页当增量结果，这里直接跳过
            if (account.channelName && account.channelName !== 'customer') {
                return;
            }
            // 取当前会话本地已加载的最后一条消息时间戳作为补拉基准
            const history = context.state.chatHistory || [];
            let sinceTimestamp = 0;
            for (let i = history.length - 1; i >= 0; i--) {
                if (history[i] && history[i].timestamp != null) {
                    sinceTimestamp = history[i].timestamp;
                    break;
                }
            }
            // 本地尚无消息则交给正常历史加载流程，避免全量拉取
            if (!sinceTimestamp) {
                return;
            }
            const reqChatId = chat.chatId;
            const reqAccountId = account.accountId;
            http({
                url: '/client/historyMessages',
                method: 'GET',
                params: {
                    accountId: reqAccountId,
                    chatId: reqChatId,
                    sinceTimestamp
                }
            })
            .then((res) => {
                // 请求期间可能已切换会话，结果作废
                if (!context.state.activeChat || context.state.activeChat.chatId != reqChatId) {
                    return;
                }
                const list = (res && res.list) ? res.list : [];
                if (!list.length) {
                    return;
                }
                // 按 id 去重，补拉消息(升序)追加到末尾
                const existIds = new Set(context.state.chatHistory.map((m) => m.id));
                const fresh = list.filter((m) => m && !existIds.has(m.id));
                if (!fresh.length) {
                    return;
                }
                context.commit('setChatHistory', [...context.state.chatHistory, ...fresh]);
                // 补回的消息标记已读
                context.dispatch('markChatAsRead', {
                    context,
                    chatId: reqChatId,
                    accountId: reqAccountId
                });
            })
            .catch((err) => {
                console.error('ws重连补拉消息失败', err);
            });
        },
        // 获取历史记录列表
        getHistoryList(context) {
            if (context.state.historyPage * context.state.historyPageSize >= context.state.historyTotal) return;
            context.commit('setHistoryPage', context.state.historyPage + 1);
            return new Promise((resolve, reject) => {
                http({
                    url: '/client/historyMessages',
                    method: 'GET',
                    params: {
                        accountId: context.state.activeAccount.accountId,
                        chatId: context.state.activeChat.chatId,
                        pageNum: context.state.historyPage,
                        pageSize: context.state.historyPageSize
                    }
                })
                .then((history) => {
                    history.list = history.list.reverse();
                    context.commit('setChatHistory', [...history.list, ...context.state.chatHistory]);
                    resolve([...history.list, ...context.state.chatHistory]);
                })
                .catch((res) => {
                    reject(res);
                });
            });
        },

        // 标记当前会话为已读
        markChatAsRead(context, { chatId, accountId }) {
            // 该对话全部消息已读
            http({
                url: '/client/markChatAsRead',
                method: 'post',
                params: {
                    chatId,
                    accountId
                }
            }).then((res) => {
                // 清零会话未读后，会经由 updateChatUnreadCount -> setChats 重算当前账号红点，无需在此单独处理
                context.dispatch('updateChatUnreadCount', {
                    context,
                    chatId,
                    num: 0
                });
            });
        },

        // 根据会话id，更新会话未读消息数量
        updateChatUnreadCount(context, { chatId, num = 0, type = '-' }) {
            const updatedChats = context.state.chats.map((chat) => {
                if (chat.chatId == chatId) {
                    return {
                        ...chat,
                        unreadCount: type === 'add' ? chat.unreadCount + num : num
                    };
                }
                return chat;
            });
            context.commit('setChats', updatedChats);

            if(context.state.groupList.length == 0) return;
            const updatedGroupList = context.state.groupList.map(group => {
                return {
                    ...group,
                    chats: group.chats.map(chat => {
                    if (chat.chatId === chatId) {
                        return {
                        ...chat,
                        unreadCount: type === 'add'
                            ? chat.unreadCount + num
                            : num
                        };
                    }
                    return chat;
                    })
                };
            });
            context.commit('setGroupList', updatedGroupList);
        },
        // 根据会话id，更新最后消息时间
        updateChatLastMessageTime(context, { chatId, time }) {
            const updatedChats = context.state.chats.map((chat) => {
                if (chat.chatId == chatId) {
                    return {
                        ...chat,
                        timestamp: time
                    };
                }
                return chat;
            });
            context.commit('setChats', updatedChats);

            // 同步更新分组里的对应会话时间戳
            if (context.state.groupList && context.state.groupList.length) {
                const updatedGroupList = context.state.groupList.map(group => ({
                    ...group,
                    chats: (group.chats || []).map(chat => {
                        if (chat.chatId == chatId) {
                            return {
                                ...chat,
                                timestamp: time
                            };
                        }
                        return chat;
                    })
                }));
                context.commit('setGroupList', updatedGroupList);
            }
        },
        // 插入会话消息
        insertCicadeMessage(context, message) {
            // 账号红点：对方发来的消息(chatId == senderId)，若属于"非当前账号"，则点亮该账号红点。
            // 当前账号的红点由其会话未读求和决定(见 setChats)，不在此处理，避免重复推送造成误判。
            const realChatId = message.chatIdStr ? message.chatIdStr : message.chatId;
            const isInbound = realChatId == message.senderId;
            const activeAccountId = context.state.activeAccount && context.state.activeAccount.accountId;
            if (isInbound && message.accountId != activeAccountId) {
                context.commit('markAccountUnread', message.accountId);
            }

            let test = {
                _id: null,
                id: 148897793,
                chatId: 7236882704,
                title: 'Peter',
                senderId: '7623118858',
                text: '11',
                timestamp: 1743064526,
                type: 'text',
                fileUrl: null,
                duration: 0,
                thumbnailUrl: null,
                tgUserId: 7623118858,
                userId: 10,
                accountId: 5
            };

            // 1,会话存在且，当前展示的会话是当前会话，插入消息
            // 必须同时校验 accountId：同一访客(chatId)可能同时跟多个账号聊天，
            // 只比 chatId 会把"发给别的账号"的消息串进当前打开的会话(负责人代看多账号时尤其明显)
            if (context.state.activeChat && context.state.activeChat.chatId == (message.chatIdStr?message.chatIdStr:message.chatId)
                && message.accountId == context.state.activeAccount?.accountId) {
                // 一条消息会推送2次 这里根据ID判断是否存在， 如果存在调用updateCicadeMessage 方法更新
                if (context.state.chatHistory.find((msg) => msg.id == message.id)) {
                    context.dispatch('updateCicadeMessage', {
                        context,
                        messageId: message.id,
                        message: message
                    });
                } else {
                    console.log('🔥正常插入消息', message);
                    // 正常插入消息
                    context.commit('setChatHistory', [...context.state.chatHistory, message]);

                    // 更新会话最后消息时间
                    context.dispatch('updateChatLastMessageTime', {
                        context,
                        chatId: message.chatIdStr?message.chatIdStr:message.chatId,
                        time: message.timestamp
                    });
                }
                // 每次都将该条消息已读
                if(message.chatIdStr?message.chatIdStr:message.chatId == message.senderId){
                    http({
                        url: '/client/markAsRead',
                        method: 'POST',
                        params: {
                            messageId: message.id,
                            chatId: message.chatIdStr?message.chatIdStr:message.chatId,
                            accountId: message.accountId
                        }
                    });
                }
                // 2.如果是当前账号的消息，但是会话列表不存在，则刷新会话列表
            } else if (message.accountId == context.state.activeAccount.accountId && !context.state.chats.find((chat) => chat.chatId == (message.chatIdStr?message.chatIdStr:message.chatId))) {
                // 刷新会话列表
                // context.dispatch('loadCicadeChat');
                // 陌生人插入会话插入分组
                context.commit('addStrangerToChat',message)
                // 更新会话未读消息数量
                if(message.chatId == message.senderId){
                    // 更新会话未读消息数量
                    context.dispatch('updateChatUnreadCount', {
                        context,
                        chatId: message.chatIdStr?message.chatIdStr:message.chatId,
                        num: 1,
                        type: 'add'
                    });
                }
                // 更新会话最后消息时间
                context.dispatch('updateChatLastMessageTime', {
                    context,
                    chatId: message.chatIdStr?message.chatIdStr:message.chatId,
                    time: message.timestamp
                });

            } else if (message.accountId == context.state.activeAccount.accountId && context.state.chats.find((chat) => chat.chatId == (message.chatIdStr?message.chatIdStr:message.chatId))) {
                // 更新会话未读消息数量
                console.log('====message====',message);

                if(message.chatIdStr?message.chatIdStr:message.chatId == message.senderId){
                    context.dispatch('updateChatUnreadCount', {
                        context,
                        chatId: message.chatIdStr?message.chatIdStr:message.chatId,
                        num: 1,
                        type: 'add'
                    });
                }

                // 更新会话最后消息时间
                context.dispatch('updateChatLastMessageTime', {
                    context,
                    chatId: message.chatIdStr?message.chatIdStr:message.chatId,
                    time: message.timestamp
                });
            }
        },
        // 更新某一条消息
        updateCicadeMessage(context, { messageId, message }) {
            // 兼容增量推送，避免覆盖已有字段，同时合并翻译结果
            const updatedChatHistory = context.state.chatHistory.map((msg) => {
                if (msg.id == messageId) {
                    const mergedTranslations = {
                        ...(msg.translations || {}),
                        ...(message?.translations || {})
                    };
                    return {
                        ...msg,
                        ...message,
                        ...(Object.keys(mergedTranslations).length ? { translations: mergedTranslations } : {})
                    };
                }
                return msg;
            });
            context.commit('setChatHistory', updatedChatHistory);
        },
        // 加载用户画像
        loadUserProfile(context, callback = null) {
            http({
                url: '/client/profile',
                method: 'GET',
                params: { accountId: context.state.activeAccount.accountId, chatId: context.state.activeChat.chatId }
            }).then((userPortraitMongo) => {
                callback && callback(userPortraitMongo.portraitInfo);
                context.commit('setUserPortraitMongo', userPortraitMongo);
            });
        },
        // 加载用户web环境
        loadUserWebEnv(context) {
            http({
                url: 'customer/report',
                method: 'post',
                data: { accountId: context.state.activeAccount.accountId, userId: context.state.activeChat.chatId }
            }).then((data) => {
                context.commit('setUserWebEnv', data);
            });
        },

        // 更新用户画像
        updateUserProfile(context, { userProfile, callback = null }) {
            http({
                url: '/client/updateProfile',
                method: 'POST',
                data: {
                    accountId: context.state.activeAccount.accountId,
                    chatId: context.state.activeChat.chatId,
                    userPortraitMongo: {
                        ...context.state.userPortraitMongo,
                        portraitInfo: userProfile
                    }
                }
            }).then((res) => {
                callback && callback();
            });
        },

        recallMessage(context,params){
            http({
                url: '/client/withdraw',
                method: 'post',
                data: { id: params.id, accountId: params.accountId, channelName: context.state.activeChannel.channelName }
            }).then((res) => {
                const arr = context.state.chatHistory.filter(item=>item.id!=params.id);
                context.commit('setChatHistory',arr);
            });
        },
        recall(context,message){
            const arr = context.state.chatHistory.filter(item=>item.id!=message.id);
            context.commit('setChatHistory',arr);
        },
        updateGroupList(context) {
            // 复制数组再排序，避免直接修改 state
            const updatedGroupList = [...context.state.groupList].sort((a, b) => {
                // 1. 置顶排序 (isSticky: true 在前)
                if ((b.isSticky ? 1 : 0) !== (a.isSticky ? 1 : 0)) {
                    return (b.isSticky ? 1 : 0) - (a.isSticky ? 1 : 0);
                }

                // 2. 置顶时间排序 (stickyTime: 最新的在前)
                if (a.isSticky && b.isSticky) {
                    const aTime = Number(a.stickyTime) || 0;
                    const bTime = Number(b.stickyTime) || 0;
                    if (bTime !== aTime) return bTime - aTime;
                }

                // 3. 标记排序 (有 portraitValues 的在前)
                if ((b.portraitValues ? 1 : 0) !== (a.portraitValues ? 1 : 0)) {
                    return (b.portraitValues ? 1 : 0) - (a.portraitValues ? 1 : 0);
                }

                // 4. 时间戳排序 (timestamp: 最新的在前)
                const aTimestamp = a.timestamp ? Number(a.timestamp) : 0;
                const bTimestamp = b.timestamp ? Number(b.timestamp) : 0;
                return bTimestamp - aTimestamp;
            });

            context.commit('setGroupList', updatedGroupList);
        }
    },
    getters: {
        // findChats: (state) => () => {
        //     return state.chats;
        // },
        // findChat: (state) => (chatId) => {
        //     return state.chats.find((chat) => chat.id === chatId);
        // }
    }
};
